var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", {
    class: {
      spinner: true,
      "spinner--inline": _vm.inline,
      "spinner--small": _vm.small,
      "spinner--tiny": _vm.tiny,
      "spinner--white": _vm.white,
      "spinner--grey": _vm.grey
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }